import { Box, xcss } from '@atlaskit/primitives';
import SelectOptionTag from '@databases/tag/SelectOptionTag';
import { DatabaseFieldType } from '@databases/types/database';
import React, { FunctionComponent } from 'react';

import { ViewComponentProps } from './types';

const SelectValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.SELECT>
> = ({ field, value }) => {
  return (
    <Box
      testId="select-value-view"
      xcss={xcss({
        width: '100%',
      })}
    >
      {field.settings.selectOptions.flatMap((option) => {
        if (!value.some((val) => val === (option.id ?? option.label))) {
          return [];
        }

        return [<SelectOptionTag key={option.id ?? option.label} option={option} />];
      })}
    </Box>
  );
};

export default SelectValueView;
